import { forwardRef } from 'react';

import { ResponsiveRosterCollection } from '@wwe-portal/ui/features/roster';

import { SectionLayout } from './section-layout';
import { PlayerRosterForClubStore } from '@wwe-portal/entities/roster.type';

export interface ExclusiveRecruitmentSectionProps {
  title: React.ReactNode;
  description: React.ReactNode;
  isLoading: boolean;
  rosters: PlayerRosterForClubStore[] | undefined;
  total: number | undefined;
  onItemClick: (id: string) => void;
  onViewMoreRosters: () => void;
}

export const ExclusiveRecruitmentSection = forwardRef<
  HTMLDivElement,
  ExclusiveRecruitmentSectionProps
>(
  (
    {
      title,
      description,
      rosters,
      total,
      isLoading,
      onItemClick,
      onViewMoreRosters,
    },
    ref
  ) => {
    return (
      <SectionLayout description={description} ref={ref} title={title}>
        <ResponsiveRosterCollection
          hasUpgradeIcon={false}
          isLoading={isLoading}
          onItemClick={onItemClick}
          onViewMoreRosters={onViewMoreRosters}
          rosters={rosters}
          total={total}
        />
      </SectionLayout>
    );
  }
);

ExclusiveRecruitmentSection.displayName = 'ExclusiveRecruitmentSection';
